export const PathwaysTrackEvents = eventList => {
  const instance = window.ins;
  eventList.map(item =>
    instance.trackEvent({
      category: item.category,
      action: item.action
    })
  );
};
